namespace GeniuzPOS.ReportMasterData {
    export class Report_1409Columns {
        static columnsKey = 'ReportMasterData.Report_1409';
    }
}
